import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import { defineComponent as _defineComponent } from 'vue';
import { containsNonNullOrNonEmptyObject } from '~/helpers/containsArrayIsNonNull';
import ItemSeparator from '~/components/ui/ItemSeparator.vue';
import RichText from '~/components/ui/RichText.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import { useGetDisplayOptionsClasses } from '~/composables/useGetDisplayOptionsClasses';
import useRightPath from '~/composables/useRightPath';
import { useProductsMinimalFromSkus } from '~/composables/useProductsMinimalFromSkus';
import { getMainImage } from '~/helpers/productCardMethods';
import { getPagePrefix } from '~/composables/useInternalLink';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ItemImageTextTwo',
  props: {
    items: {
      default: function _default() {
        return [];
      }
    },
    title: null,
    topContent: null,
    bottomContent: null,
    displayOptions: {
      default: function _default() {
        return [];
      }
    },
    isInExpandableTab: {
      type: Boolean
    },
    isInTabContainer: {
      type: Boolean
    },
    isTheOnlyItem: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      locale = _useNuxt2App.i18n.locale;
    var itemsFields = computed(function () {
      return props.items.map(function (item) {
        var _item$fields;
        return (_item$fields = item.fields) !== null && _item$fields !== void 0 ? _item$fields : item;
      }).filter(Boolean);
    });
    var productSkus = computed(function () {
      return itemsFields.value.filter(function (item) {
        return !!item.productSku;
      }).map(function (item) {
        return item.productSku;
      });
    });
    var _useProductsMinimalFr = useProductsMinimalFromSkus(productSkus.value),
      searchProductsMinimalFromSkus = _useProductsMinimalFr.search,
      products = _useProductsMinimalFr.products;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    useLazyAsyncData("fetch-slugs-".concat(productSkus.toString()), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!containsNonNullOrNonEmptyObject(productSkus.value)) {
              _context.next = 3;
              break;
            }
            _context.next = 3;
            return searchProductsMinimalFromSkus();
          case 3:
            return _context.abrupt("return", true);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    function getRelationType(item) {
      var relation = item.relationWithNextItem;
      if (!relation) return null;
      if (relation.includes('+')) return 'plus';
      if (relation.includes('=')) return 'equals';
      return 'or';
    }
    function findProduct(item) {
      return products.value.find(function (p) {
        return p && p.sku === item.productSku;
      });
    }
    function firstText(item) {
      var _item$firstText, _findProduct;
      return (_item$firstText = item.firstText) !== null && _item$firstText !== void 0 ? _item$firstText : (_findProduct = findProduct(item)) === null || _findProduct === void 0 ? void 0 : _findProduct.name;
    }
    function secondText(item) {
      return item.secondText;
    }
    function getProperLink(link) {
      var _link$sys, _link$sys$contentType, _link$sys$contentType2, _link$fields;
      return "/".concat(getPagePrefix((_link$sys = link.sys) === null || _link$sys === void 0 ? void 0 : (_link$sys$contentType = _link$sys.contentType) === null || _link$sys$contentType === void 0 ? void 0 : (_link$sys$contentType2 = _link$sys$contentType.sys) === null || _link$sys$contentType2 === void 0 ? void 0 : _link$sys$contentType2.id, locale), "/").concat((_link$fields = link.fields) === null || _link$fields === void 0 ? void 0 : _link$fields.slug);
    }
    function link(item) {
      var internalLink = item.internalLink;
      var manualLink = item.manualLink;
      var productSku = item.productSku;
      if (internalLink) {
        return {
          url: getProperLink(internalLink),
          isManualLink: true,
          hasLink: true
        };
      }
      if (manualLink) {
        return {
          url: manualLink,
          isManualLink: true,
          hasLink: true
        };
      }
      if (productSku) {
        var product = findProduct(item);
        if (product) {
          return {
            url: getProductPath(product),
            isManualLink: false,
            hasLink: true
          };
        }
      }
      return {
        url: '',
        isManualLink: false,
        hasLink: false
      };
    }
    function imageLink(item) {
      var _item$internalLink, _item$internalLink$fi, _item$internalLink$fi2, _item$internalLink$fi3, _item$internalLink$fi4, _item$internalLink$fi5, _item$image, _item$image$fields, _item$image$fields$fi, _item$image2;
      var product = findProduct(item);
      var internalLinkImage = (_item$internalLink = item.internalLink) === null || _item$internalLink === void 0 ? void 0 : (_item$internalLink$fi = _item$internalLink.fields) === null || _item$internalLink$fi === void 0 ? void 0 : (_item$internalLink$fi2 = _item$internalLink$fi.imagesCarousel) === null || _item$internalLink$fi2 === void 0 ? void 0 : (_item$internalLink$fi3 = _item$internalLink$fi2[0]) === null || _item$internalLink$fi3 === void 0 ? void 0 : (_item$internalLink$fi4 = _item$internalLink$fi3.fields) === null || _item$internalLink$fi4 === void 0 ? void 0 : (_item$internalLink$fi5 = _item$internalLink$fi4.file) === null || _item$internalLink$fi5 === void 0 ? void 0 : _item$internalLink$fi5.url;
      var imageUrl = ((_item$image = item.image) === null || _item$image === void 0 ? void 0 : (_item$image$fields = _item$image.fields) === null || _item$image$fields === void 0 ? void 0 : (_item$image$fields$fi = _item$image$fields.file) === null || _item$image$fields$fi === void 0 ? void 0 : _item$image$fields$fi.url) || ((_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.url);
      return imageUrl || internalLinkImage || (product ? getMainImage(product) : '');
    }
    var classes = useGetDisplayOptionsClasses(props.displayOptions);
    return {
      __sfc: true,
      props: props,
      locale: locale,
      itemsFields: itemsFields,
      productSkus: productSkus,
      searchProductsMinimalFromSkus: searchProductsMinimalFromSkus,
      products: products,
      getProductPath: getProductPath,
      getRelationType: getRelationType,
      findProduct: findProduct,
      firstText: firstText,
      secondText: secondText,
      getProperLink: getProperLink,
      link: link,
      imageLink: imageLink,
      classes: classes,
      ItemSeparator: ItemSeparator,
      RichText: RichText,
      AzImg: AzImg,
      NuxtLinkCustom: NuxtLinkCustom
    };
  }
});